<template>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>电卡维护</el-breadcrumb-item>
        <el-breadcrumb-item>电卡管理</el-breadcrumb-item>
      </el-breadcrumb>
      <el-card>
        <el-row :gutter="0">
          <el-col :span="10">
            <el-input
              placeholder="请输入查询内容"
              v-model="queryInfo.query"
              class="input-with-select"
              clearable
              style="width:300px "
              @clear="getdiankaList"
              @change="getdiankaList"
            >
              <el-button slot="append" icon="el-icon-search" @click="getdiankaList"></el-button>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="get_dianka_add" v-if="false">添加电卡</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="0" class="el_row_two">
          <el-col :span="24">
            <el-table :data="diankaList" style="width: 100%" bdianka stripe>
              <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
              <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
              <el-table-column prop="baoyue_day" label="日"></el-table-column>
              <el-table-column prop="baoyue_hour" label="小时"></el-table-column>
              <el-table-column prop="start_time" label="开始时间"></el-table-column>
              <el-table-column prop="end_time" label="结束时间"></el-table-column>
              <el-table-column prop="order_money" label="订单金额"></el-table-column>
              <el-table-column prop="order_time" label="购买日期"></el-table-column>
              <el-table-column prop="gonglv" label="功率" width="130" v-if="false">
                <template v-slot="scope"> <span> {{scope.row.pay_flag === 1 ? '已支付':'未支付' }}</span></template>
              </el-table-column>
              
              <el-table-column label="操作" v-if="false">
                <template v-slot="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="修改"
                    placement="top"
                    :enterable="false"
                  >
                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      @click="showEditDialog(scope.row.uid)"
                      circle
                      size="mini"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="top"
                    :enterable="false"
                  >
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      circle
                      size="mini"
                      @click="deleteForm(scope.row.uid)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="电卡回访"
                    placement="top"
                    :enterable="false"
                    style="display: none;"
                  >
                    <el-button
                      type="success"
                      icon="el-icon-orange"
                      @click="showHuifangDialog(scope.row.uid)"
                      circle
                      size="mini"
                    ></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.pageNum"
          :page-sizes="[10,50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
          <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
        </el-pagination>
        <!-- 电卡回访窗口 -->
  
        <el-dialog
          title="电卡回访"
          :visible.sync="huifangDialogVisible"
          width="50%"
          @close="huifangDoalogClosed"
        >
          <el-form
            ref="huifangFormRef"
            :model="huifangForm"
            :rules="huifangFormRefRules"
            label-width="100px"
          >
            <el-card class="card_two" style="height:140px; margin-top:0px; margin-bottom:20px; ">
              <el-row :gutter="20">
                <el-col :span="10">
                  <div class="grid-content bg-purple">
                    <el-form-item label="电卡编号" prop="dianka_bianhao">{{editForm.dianka_bianhao}}</el-form-item>
                    <el-form-item label="电卡姓名" prop="dianka_name">{{editForm.dianka_name}}</el-form-item>
                  </div>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content bg-purple">
                    <el-form-item label="联系手机号" prop="dianka_mob">{{editForm.dianka_mob}}</el-form-item>
                    <el-form-item label="联系地址" prop="dianka_addr">{{editForm.dianka_addr}}</el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-card>
            <el-form-item label="回访标题" prop="huifang_title">
              <el-input v-model="huifangForm.huifang_title" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="回访内容" prop="hufiang_memo">
              <el-input
                v-model="huifangForm.hufiang_memo"
                :autosize="{ minRows: 2, maxRows: 8}"
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否需要跟进" prop="huifang_genjin">
              <el-switch
                v-model="huifangForm.huifang_switch"
                @change="get_switch_value(huifangForm.huifang_switch)"
              ></el-switch>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="huifangDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addHuifang" :disabled="huifang_isDisable">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 添加电卡部分 -->
        <el-dialog title="添加电卡" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
          <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
            <el-form-item label="电卡编号" prop="dianka_bianhao">
              <el-input v-model="addForm.dianka_bianhao" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="电卡姓名" prop="dianka_name">
              <el-input v-model="addForm.dianka_name"></el-input>
            </el-form-item>
            <el-form-item label="联系手机号" prop="dianka_mob">
              <el-input v-model="addForm.dianka_mob" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="联系地址" prop="dianka_addr">
              <el-input v-model="addForm.dianka_addr" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="dianka_sfz_bianhao">
              <el-input v-model="addForm.dianka_sfz_bianhao" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="电卡等级" prop="dianka_level">
              <el-select v-model="addForm.dianka_level" placeholder="请选择电卡等级">
                <el-option
                  v-for="item in dianka_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="电卡心理价位" prop="dianka_addr">
              <el-input v-model="addForm.dianka_price_want" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="电卡意向" prop="dianka_addr">
              <el-input v-model="addForm.dianka_yixiang" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="电卡备注" prop="dianka_addr">
              <el-input v-model="addForm.dianka_memo" max="11" min="10"></el-input>
            </el-form-item>
  
            <el-form-item label="电卡来源" prop="dianka_laiyuan">
              <el-select v-model="addForm.dianka_laiyuan" placeholder="请选择电卡来源">
                <el-option
                  v-for="item in diankaLy_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="adddianka" :disabled="add_isDisable">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 修改电卡信息 -->
        <el-dialog
          title="修改电卡信息"
          :visible.sync="editDialogVisible"
          width="50%"
          @close="editDoalogClosed"
        >
          <el-form ref="editFormRef" :model="editForm" :rules="addFormRules" label-width="100px">
            <el-form-item label="电卡编号" prop="dianka_bianhao">
              <el-input v-model="editForm.dianka_bianhao" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="电卡姓名" prop="dianka_name">
              <el-input v-model="editForm.dianka_name"></el-input>
            </el-form-item>
            <el-form-item label="联系手机号" prop="dianka_mob">
              <el-input v-model="editForm.dianka_mob" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="联系地址" prop="dianka_addr">
              <el-input v-model="editForm.dianka_addr" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="dianka_sfz_bianhao">
              <el-input v-model="editForm.dianka_sfz_bianhao" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="电卡等级" prop="dianka_level">
              <el-select v-model="editForm.dianka_level" placeholder="请选择电卡等级">
                <el-option
                  v-for="item in dianka_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="电卡心理价位" prop="dianka_addr">
              <el-input v-model="editForm.dianka_price_want" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="电卡意向" prop="dianka_addr">
              <el-input v-model="editForm.dianka_yixiang" max="11" min="10"></el-input>
            </el-form-item>
            <el-form-item label="电卡备注" prop="dianka_addr">
              <el-input v-model="editForm.dianka_memo" max="11" min="10"></el-input>
            </el-form-item>
  
            <el-form-item label="电卡来源" prop="dianka_laiyuan">
              <el-select v-model="editForm.dianka_laiyuan" placeholder="请选择电卡来源">
                <el-option
                  v-for="item in diankaLy_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="editDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="updatedianka">确 定</el-button>
          </span>
        </el-dialog>
      </el-card>
    </div>
  </template>
  <script>
   import { checkMobileTest, checkSfzId } from './config/validator';
  export default {
    data() {
      return {
        diankaLy_options: [
          {
            value: 1,
            label: '电卡介绍'
          },
          {
            value: 2,
            label: '回访电卡'
          },
          {
            value: 3,
            label: '上门电卡'
          }
        ],
        dianka_options: [
          {
            value: 1,
            label: '初级电卡'
          },
          {
            value: 2,
            label: '中级电卡'
          },
          {
            value: 3,
            label: '高级电卡'
          }
        ],
        // 获取用户列表参数
        queryInfo: {
          C_type: 'get_list',
          C_table_name: 'dianka_list',
          query: '',
          pageNum: 1,
          pageSize: 10,
          qiye_uid: window.sessionStorage.getItem('qiye_uid')
        },
        huifang_isDisable: false,
        add_isDisable: false,
        diankaList: [],
        //  recordCount: 0,
        total: 0,
        addDialogVisible: false,
        editDialogVisible: false,
        huifangDialogVisible: false,
  
        // 用于设置回访页面滑块值
        //  添加表单数据项
        huifangForm: {
          C_type: 'huifang_add',
          huifang_dianka_uid: 0,
          huifang_title: '',
          hufiang_memo: '',
          huifang_genjin: 1,
          huifang_yuangong_uid: 0,
          huifang_switch: true
        },
        addForm: {
          C_type: 'dianka_add',
          dianka_bianhao: '',
          dianka_name: '',
          dianka_mob: '11111111111',
          dianka_addr: '',
          dianka_sfz_bianhao: '111111111111111111',
          dianka_level: 1,
          dianka_price_want: 0,
          dianka_yixiang: '',
          dianka_memo: '',
          dianka_laiyuan: 1
        },
        // 用于修改数据绑定
        editForm: {},
        // 表单规则项
        addFormRules: {
          dianka_name: [
            { required: true, message: '请输入电卡名称', trigger: 'blur' },
            { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
          ],
  
          dianka_mob: [
            {
              validator: checkMobileTest.bind(
                this.addForm && this.addForm.dianka_mob
              )
            }
          ],
          dianka_sfz_bianhao: [
            {
              validator: checkSfzId.bind(
                this.addForm && this.addForm.dianka_sfz_bianhao
              )
            }
          ]
        },
  
        huifangFormRefRules: {
          huifang_title: [
            { required: true, message: '请输入回访标题', trigger: 'blur' },
            { min: 1, max: 1000, message: '必须1位字符 ', trigger: 'blur' }
          ]
        }
      };
    },
    created() {
      this.getdiankaList();
    },
    methods: {
      get_switch_value(switchValue) {
        this.huifangForm.huifang_genjin = switchValue ? 1 : 0;
        console.log(this.huifangForm.huifang_genjin);
      },
      async huiFangAdd() {
        const { data: res } = await this.$http.post('api', this.huifangForm);
        console.log(JSON.parse(res.data)[0].bianhao_s);
        this.huifangDialogVisible = true;
      },
      async get_dianka_add() {
        const { data: res } = await this.$http.get('get_api', {
          params: { C_type: 'get_bianhao', C_table_type: 3 }
        });
        console.log(JSON.parse(res.data)[0].bianhao_s);
        this.addForm.dianka_bianhao = JSON.parse(res.data)[0].bianhao_s;
        // this.total = JSON.parse(res.data)[0].total
        this.addDialogVisible = true;
      },
  
      async getdiankaList() {
        const { data: res } = await this.$http.get('get_api', {
          params: this.queryInfo
        });
        // console.log(JSON.parse(res.data))
        this.diankaList = JSON.parse(res.data)[0].dataList;
  
        if (!this.diankaList) return;
        this.diankaList.forEach(function(item) {
          item.yong_flag = item.yong_flag === 1;
        });
  
        this.total = JSON.parse(res.data)[0].total;
  
        // console.log(this.total)
      },
      //  分页第一项下拉触发
  
      handleSizeChange(newSize) {
        this.queryInfo.pageSize = newSize;
        this.getdiankaList();
      },
      // 选择页数触发
      handleCurrentChange(newPage) {
        this.queryInfo.pageNum = newPage;
        this.getdiankaList();
      },
  
      async adddianka() {
        this.$refs.addFormRef.validate(async valid => {
          if (!valid) return 1;
           this.add_isDisable = true
           setTimeout(() => {
             this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
         }, 2000)
          const { data: res } = await this.$http.post('api', this.addForm);
          console.log(JSON.parse(res.data)[0].status);
          if (JSON.parse(res.data)[0].status === 201) {
              this.$message.error('手机号码重复')
              return
            } else if ((JSON.parse(res.data)[0].status !== 200) && (JSON.parse(res.data)[0].status !== 201)) {
            this.$message.error('添加失败')
            return
          }
          this.$message.success('添加成功');
          this.getdiankaList();
          this.addDialogVisible = false;
        });
      },
      async addHuifang() {
        this.$refs.huifangFormRef.validate(async valid => {
          if (!valid) return 1;
          this.huifang_isDisable = true
         setTimeout(() => {
             this.huifang_isDisable = false // 点击一次时隔两秒后才能再次点击
         }, 2000)
  
          const { data: res } = await this.$http.post('api', this.huifangForm);
          console.log(JSON.parse(res.data)[0].status);
          if (JSON.parse(res.data)[0].status !== 200) {
            this.$message.error('添加失败');
            return;
          }
          this.$message.success('添加成功');
          this.getdiankaList();
          this.huifangDialogVisible = false;
        });
      },
      showEditDialog(uid) {
         this.diankaInfo(uid);
        this.editDialogVisible = true;
      },
      addDoalogClosed() {
        this.$refs.addFormRef.resetFields();
      },
      huifangDoalogClosed() {
        this.$refs.huifangFormRef.resetFields();
      },
      showHuifangDialog(uid) {
        this.huifangDialogVisible = true;
        this.diankaInfo(uid);
      },
      editDoalogClosed() {
        this.$refs.editFormRef.resetFields();
      },
      async diankaInfo(uid) {
        const { data: res } = await this.$http.get('get_api', {
          params: { C_table_name: 'dianka_info', uid: uid, C_type: 'get_info' }
        });
        // console.log(JSON.parse(res.data))
        console.log(res.data);
        if (JSON.parse(res.data)[0].status !== 200) {
          return this.$message.error('读取失败');
        }
  
        this.editForm = JSON.parse(res.data)[0].data[0];
        this.huifangForm.huifang_dianka_uid = JSON.parse(res.data)[0].data[0].uid;
      },
      async updatedianka() {
        this.$refs.editFormRef.validate(async valid => {
          if (!valid) return this.$message.error('验证错误！');
          this.editForm.C_type = 'dianka_update';
          // 对象加入一个项C_type
          const { data: res } = await this.$http.post('api', {
            C_type: 'dianka_update',
            dianka_bianhao: this.editForm.dianka_bianhao.trim(),
            dianka_name: this.editForm.dianka_name,
            dianka_mob: this.editForm.dianka_mob,
            dianka_addr: this.editForm.dianka_addr,
            dianka_sfz_bianhao: this.editForm.dianka_sfz_bianhao,
            dianka_level: this.editForm.dianka_level,
            dianka_price_want: this.editForm.dianka_price_want,
            dianka_yixiang: this.editForm.dianka_yixiang,
            dianka_memo: this.editForm.dianka_memo,
            dianka_laiyuan: this.editForm.dianka_laiyuan,
            dianka_uid: this.editForm.uid
          });
  
          if (JSON.parse(res.data)[0].status !== 200) {
            this.$message.error('更新失败');
            return;
          }
          this.$message.success('更新成功');
          this.getdiankaList();
          this.editDialogVisible = false;
        });
      },
      // 删除一条记录
      async deleteForm(diankaUid) {
        // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
        // 异步操作有2个，1个对话框等待，1个是网络请求
        const comfirmResult = await this.$confirm(
          '确定删除该条记录, 是否继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).catch(err => err);
        console.log(comfirmResult);
        if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
        const { data: res } = await this.$http.post('api', {
          C_type: 'record_delete',
          C_table_name: 'dianka_del',
          C_data1: diankaUid
        });
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('删除失败');
          return;
        }
        this.$message.success('删除成功');
        this.getdiankaList();
      }
    }
  };
  </script>
  <style lang="less" scoped>
  .card_two {
    margin-top: 30px;
    box-shadow: none !important ;
    background-color: #f2f6fc;
  }
  .el_row_two {
    margin-top: 30px;
  }
  </style>
